module.exports = __webpack_public_path__ + "img/476.4d15ffcf.jpg";